import {
  Injectable,
  EmbeddedViewRef,
  ApplicationRef, ComponentRef, ViewContainerRef
} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DomService {

  constructor(private appRef: ApplicationRef) { }

  appendComponentToBody(component: any) {
    const componentRef = this.getRootViewContainerRef().createComponent(component);
    (<any>componentRef.instance).componentRef = componentRef;
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  getRootViewContainerRef(): ViewContainerRef {
    const appInstance = this.appRef.components[0].instance;

    if (!appInstance.viewContainerRef) {
      const appName = this.appRef.componentTypes[0].name;
      throw new Error(`Missing 'viewContainerRef' declaration in ${appName} constructor`);
    }

    return appInstance.viewContainerRef;
  }

  destroy(ref: ComponentRef<any>) {
    this.appRef.detachView(ref.hostView);
    ref.destroy();
  }
}
